import { IClassStayMealInfo } from 'src/containers/CareerStayMeal';
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/**
 * カテゴリ検索ツリーアイテム
 */
export interface ISearchCategoryItem {
	id: string;
	text: string;
	level: number;
	type: number;
	checkBoxDisplayFlg: boolean;
	treeChildren?: ISearchCategoryItem[];
	careerType: number;
}

/**
 * 研修情報
 */
export interface ICareerInfo {
	managementCode?: string; // 管理番号
	careerTitle?: string; // 研修名
	careerTypeID?: number; // 研修種別ID
	careerTypeName?: string; // 研修種別名
	careerSubType?: string; // サブ種別
	compulsoryID?: string; // 区分
	target?: string; // 対象
	organizer?: string; // 教育主催者
	purpose?: string; // 目的
	outline?: string; // 概要
	contents?: ICareerInfoContents[]; // 学習項目
	months?: string; // 期間
	credit?: string; // 単位
	studyTime?: string; // 標準学習時間
	author?: string; // 作成者
	version?: string; // バージョン
	materialFiles?: any[]; // material files
	textbook?: string; // 資料
	informationURL?: string; // 資料URL
	vendor?: string; // ベンダ名
	vendorURL?: string; // ベンダURL
	inquiry?: string; // 問い合わせ先
	reference?: string; // 申込み先
	referenceURL?: string; // 申込み先URL
	webAppFlg?: string; // Web申込
	enquete?: string; // アンケート
	careerReport?: string; // 課題
	comment?: string; // 備考
	careerGeneralMst1?: string; // 汎用マスタ属性1
	careerGeneralMst2?: string; // 汎用マスタ属性2
	careerGeneralMst3?: string; // 汎用マスタ属性3
	careerGeneralMst4?: string; // 汎用マスタ属性4
	careerGeneralMst5?: string; // 汎用マスタ属性5
	careerGeneralMst6?: string; // 汎用マスタ属性6
	careerGeneralMst7?: string; // 汎用マスタ属性7
	careerGeneralMst8?: string; // 汎用マスタ属性8
	careerGeneralMst9?: string; // 汎用マスタ属性9
	careerGeneralMst10?: string; // 汎用マスタ属性10
	careerGeneralNum1?: number; // 汎用数値属性1
	careerGeneralNum2?: number; // 汎用数値属性2
	careerGeneralNum3?: number; // 汎用数値属性3
	careerGeneralNum4?: number; // 汎用数値属性4
	careerGeneralNum5?: number; // 汎用数値属性5
	careerGeneralText1?: string; // 汎用属性1
	careerGeneralText2?: string; // 汎用属性2
	careerGeneralText3?: string; // 汎用属性3
	careerGeneralText4?: string; // 汎用属性4
	jyukoNoClass?: string; // 指定なしクラス申請FLG
	careerID?: string; // 研修ID
	haveContents?: number; // eラーニングコンテンツ有無フラグ
}

/**
 * クラス情報
 */
export interface ICareerClass {
	className?: string; // 研修名
	startDate?: string; // 開催日付
	endDate?: string; // 終了日付
	classRoomNm?: string; // 教室(プルダウン)
	classroom?: string; // 教室
	classroomDefault?: string; // 教室
	capacity?: string; // 定員
	cost?: string; // 費用
	cost1?: string; // 自己負担額
	applicationStartline?: string; // 申請開始日付
	applicationDeadline?: string; // 申請終了日付
	classStartDate?: string; // キャリア表示期間（開始）
	classEndDate?: string; // キャリア表示期間（終了）
	placeUrl?: string; // 地図のURL
	placeUrlDefault?: string; // 地図のURL
	placeFileName?: string; // 地図のファイル名
	placeFileNameDefault?: string; // 地図のファイル名
	application?: string; // 申請開始文字列
	startToEndDate?: string; // 開催開始終了文字列
	classID?: string; // クラスID
	careerID?: string; // キャリアID
}

/**
 * カリキュラム情報
 */
export interface ICurriculumInfo {
	careerId?: string; // カリキュラムID
	careerName?: string; // カリキュラム名
	managementCode?: string; // 管理番号
	purpose?: string; // 目的
	outline?: string; // 概要
	organizer?: string; // 主催者
	credit?: number; // 必要単位
	level?: string; // レベル名
	division?: string; // 学習区分名
	field?: string; // 専門分野名
	reference?: string; // 参考
	referenceUrl?: string; // 参考URL
	applicationPlace?: string; // 申込先名
	completeJudgment?: string; // 設定基準
	target?: string; // 対象者
	comment?: string; // 備考
	targetOfficeName1?: string; // 対象事業所名1
	targetOfficeName2?: string; // 対象事業所名2
	targetOfficeName3?: string; // 対象事業所名3
	targetOfficeName4?: string; // 対象事業所名4
	targetOfficeName5?: string; // 対象事業所名5
	targetSectionName1?: string; // 対象組織1
	targetSectionName2?: string; // 対象組織2
	targetSectionName3?: string; // 対象組織3
	targetSectionName4?: string; // 対象組織4
	targetSectionName5?: string; // 対象組織5
	targetPostName1?: string; // 対象役職名1
	targetPostName2?: string; // 対象役職名2
	targetPostName3?: string; // 対象役職名3
	targetPostName4?: string; // 対象役職名4
	targetPostName5?: string; // 対象役職名5
	targetEmployeeDivisionName1?: string; // 対象従業員区分名1
	targetEmployeeDivisionName2?: string; // 対象従業員区分名2
	targetEmployeeDivisionName3?: string; // 対象従業員区分名3
	targetEmployeeDivisionName4?: string; // 対象従業員区分名4
	targetEmployeeDivisionName5?: string; // 対象従業員区分名5
	targetOccupationName1?: string; // 対象職種名1
	targetOccupationName2?: string; // 対象職種名2
	targetOccupationName3?: string; // 対象職種名3
	targetOccupationName4?: string; // 対象職種名4
	targetOccupationName5?: string; // 対象職種名5
	targetYoungWorker1?: number; // 対象入社後経過年（下限）
	targetOldWorker?: number; // 対象入社後経過年（上限）
	targetOfficeName?: string; // 対象事業所:結合名
	targetOrganizeName?: string; // 対象組織:結合名
	targetPostName?: string; // 対象役職名:結合名
	targetEmployeeDivisionName?: string; // 対象従業員区分名:結合名
	targetOccupationName?: string; // 対象職種名:結合名
	targetYoungWorker?: string; // 対象入社後経過年:結合名
}

/**
 * 研修情報_学習項目
 */
export interface ICareerInfoContents {
	contents: string; // コンテンツ
}

/**
 * 章立て情報
 */
export interface ICourseInfo {
	careerTitle?: string; // 研修名
	studyTime?: number; // 標準学習時間
	note?: string; // 備考
	scormFlg?: number; // Scormフラグ
}

/**
 * トピック情報ツリーアイテム
 */
export interface ICourseTopicItem {
	id: string;
	text: string;
	level: number;
	treeChildren?: ICourseTopicItem[];
}

/**
 * カリキュラムの従属研修情報
 */
export interface ISubCareerInfo {
	careerId?: string; // キャリアID
	careerName?: string; // キャリア名
	careerType?: string; // キャリア種別名
	managementCode?: string; // 管理番号
	credit?: number; // 単位
	subCareerSetID?: number; // 従属キャリア群ID
	careerStartDate?: string; // キャリア表示期間（開始）
	careerEndDate?: string; // キャリア表示期間（終了）
	studyOrder: string; // 受講順
}

/**
 * 検索条件
 */
export interface ICareerSearchCondition {
	careerIDs?: string[];
	careerType: string;
	categoryId: string;
	categoryName: string;
	detail: ICareerSearchDetailCondition[];
	elearning: boolean;
	endDate: string;
	freeword: string;
	jobCategory: boolean;
	lowerFlg: boolean;
	office: boolean;
	onlyWanted: boolean;
	position: boolean;
	shugo: boolean;
	startDate: string;
	targetCareerId?: string;
	targetUserId?: string;
	tuusin: boolean;
	/**
	 * 資格
	 */
	qualification: boolean;
	/**
	 * 業務経験
	 */
	workExperience: boolean;
	/**
	 * スキル診断
	 */
	assessment: boolean;
	/**
	 * その他
	 */
	sonota: boolean;
	/**
	 * スキルタイプリスト
	 */
	skillTypeList: string[];
}

/**
 * 詳細検索条件
 */
export interface ICareerSearchConditionDispInfo {
	generalList: ICareerSearchConditionDispItem[];
	[key: string]: any[];
}

/**
 * 詳細検索条件付属情報
 */
export interface ICareerSearchConditionDispItem {
	name: string;
	id: string;
	type: string;
}

/**
 * 詳細検索一覧情報
 */
export interface ISearchDetailItem {
	applicationDeadline?: string;
	careerId?: string;
	careerTitle?: string;
	careerType?: number;
	careerTypeId?: number;
	check?: string;
	classId?: string;
	className?: string;
	cost?: string;
	deadline?: string;
	endDate?: string;
	expense?: string;
	finishedFlg?: number;
	managementCode?: string;
	organizer?: string;
	period?: string;
	place?: string;
	referenceURL?: string;
	startDate?: string;
	target?: string;
	type?: string;
	webAppFlg?: string;
	msgId?: string;
	msgParams?: string[];
	checkFlag?: number;
}

/**
 * 詳細検索条件
 */
export interface ICareerSearchDetailCondition {
	type: string;
	text: string;
	items: any[];
	__type: string;
	__multiselectValues: string[];
}

/**
 * 分類マスタ
 */
export interface ICategoryMst {
	id: string;
	text: string;
	textPath: string;
	level: number;
	treeChildren?: ICategoryMst[];
}

/**
 * 受講申請情報検索条件
 */
export interface IApprovalSearchCondition {
	applies: IApply[];
	careerType: string;
}

/**
 * 受講申請クラス情報検索条件
 */
export interface IApprovalClassSearchCondition {
	careerType: string;
	targetCareerId: string;
}

/**
 * 受講申請情報
 */
export interface IApply {
	careerId: string;
	classId: string;
	cancelWaitFlg: boolean;
	approverId1: string;
	approverId2: string;
	approverId4: string;
	stayMealData: IApprovalStayMealData[];
	startDate?: string;
	endDate?: string;
}

/**
 * 申請情報
 */
export interface IApprovalItem {
	applicationDeadline: string;
	approverId1: string;
	approverId2: string;
	approverId4: string;
	approverList1: IApprover[];
	approverList2: IApprover[];
	approverList4: IApprover[];
	cancel: string;
	careerId: string;
	careerTitle: string;
	careerType: number;
	careerTypeId: number;
	check: string;
	classId: string;
	className: string;
	const: string;
	deadline: string;
	endDate: string;
	expense: number;
	finishedFlg: number;
	managementCode: string;
	needApprove1: number;
	needApprove2: number;
	needApprove4: number;
	organizer: string;
	period: string;
	place: string;
	referenceURL: string;
	startDate: string;
	status: string;
	target: string;
	type: string;
	webAppFlg: string;
	preStay: string;
	dayStay: string;
	smoking: string;
	sex: string;
	preMealMorning: string;
	preMealAfternoon: string;
	preMealEvening: string;
	dayMealMorning: string;
	dayMealAfternoon: string;
	dayMealEvening: string;
	postMealMorning: string;
	postMealAfternoon: string;
	postMealEvening: string;
	stayMealFlg: boolean;
	capacityLabel: string;
}

/**
 * 承認者
 */
export interface IApprover {
	id: string;
	name: string;
}

/**
 * 選択中研修情報
 */
export interface ISelectedCareer {
	careerId: string;
	careerType: string;
	classId: string;
}

/**
 * 受講申請結果
 */
export interface IApprovalResult {
	errorMessageList: IApprovalResultErrorMessage[];
	exceptionEndFlg: number;
	success: boolean;
}

/**
 * 受講申請結果エラーメッセージ
 */
export interface IApprovalResultErrorMessage {
	messageId: string;
	replacementStringList: string[];
}

/**
 * (宿泊・食事申込画面)実施日情報
 */
export interface IStayMealDateList {
	executionDate: string;
	date: string;
	week: string;
}

/**
 * 宿泊・食事申込情報
 */
export interface IApprovalStayMealData {
	careerID: string;
	classID: string;
	SexFlg: string;
	SmokingFlg: string;
	StayMealDateList: IClassStayMealInfo[];
	UID: string;
	Comment: string;
}

/**
 * スキル汎用コード
 */
export interface ISkillCode {
	/**
	 * ID
	 */
	id: string;

	/**
	 * 名称
	 */
	name: string;

	/**
	 * ツールチップ
	 */
	title: string;

	/**
	 * 法人ID
	 */
	companyId: string;

	/**
	 * 表示顺
	 */
	displayOrder: number;
}

export const setCourseDetailDialog = actionCreator<{
	OpenCourseDetailDialog: boolean;
}>('SET_COURSE_DETAIL_DIALOG');

export const setCurriculumDetailDialog = actionCreator<{
	OpenCurriculumDetailDialog: boolean;
}>('SET_CURRICULUM_DETAIL_DIALOG');

/**
 * (宿泊・食事申込画面)実施日情報設定アクションクリエータ
 */
export const setStayMealDateList = actionCreator<{
	dateList: IStayMealDateList[];
}>('SET_STAY_MEAL_DATE');

/**
 * (宿泊・食事申込画面)備考設定アクションクリエータ
 */
export const setStayMealCommment = actionCreator<{
	comment: string;
}>('SET_STAY_MEAL_COMMENT');

/**
 * 宿泊・食事申込画面設定アクションクリエータ
 */
export const setClassStayMealDialog = actionCreator<{
	OpenClassStayMealDialog: boolean;
}>('SET_CLASS_STAY_MEAL_DIALOG');

/**
 * 宿泊・食事申込情報設定アクションクリエータ
 */
export const setApprovalStayMealList = actionCreator<{
	approvalStayMealList: IApprovalStayMealData[];
}>('SET_APPROVAL_STAY_MEAL_DATE_LIST');

/**
 * 施設管理オプション設定アクションクリエータ
 */
export const setUseFacilityFlg = actionCreator<{
	useFacilityFlg: string;
}>('SET_USEFACILITY_FLG');

/**
 * 検索画面アクションクリエータ
 */
export const setSearchCategories = actionCreator<{
	categories: ISearchCategoryItem[];
}>('SET_SEARCH_CATEGORY');

/**
 * 研修詳細情報設定アクションクリエータ
 */
export const setCareerDetail = actionCreator<{
	careerInfo: ICareerInfo;
	careerClasses: ICareerClass[];
}>('SET_CAREER_DETAIL');

/**
 * カリキュラム詳細情報設定アクションクリエータ
 */
export const setCurriculumDetail = actionCreator<{
	curriculumInfo: ICurriculumInfo;
	showHRAttribute: string;
}>('SET_CURRICULUM_DETAIL');

/**
 * 章立て情報設定アクションクリエータ
 */
export const setCourseDetail = actionCreator<{
	courseInfo: ICourseInfo;
	courseTopics: ICourseTopicItem[];
}>('SET_COURSE_DETAIL');

/**
 * 章立て情報設定アクションクリエータ
 */
export const setCurriculumAchieveCondition = actionCreator<{
	curriculumInfo: ICurriculumInfo;
	requiredCareers: ISubCareerInfo[];
	optionalCareers: ISubCareerInfo[];
}>('SET_CURRICULUM_ACHIEVE_CONDITION');

/**
 * 検索条件設定アクションクリエータ
 */
export const setCareerSearchCondition = actionCreator<{
	value: ICareerSearchCondition;
}>('SET_CAREER_SEARCH_CONDITION');

/**
 * 詳細検索条件表示情報設定アクションクリエータ
 */
export const setCareerSearchConditionDetail = actionCreator<{
	data: ICareerSearchConditionDispInfo;
}>('SET_CAREER_SEARCH_CONDITION_DETAIL');

/**
 * 詳細検索情報設定アクションクリエータ
 */
export const setSearchDetails = actionCreator<{
	applyFlg: number;
	data: ISearchDetailItem[];
}>('SET_SEARCH_DETAILS');

/**
 * 詳細検索（申請用）情報設定アクションクリエータ
 */
export const setSearchDetailsForApply = actionCreator<{
	applyFlg: number;
	data: ISearchDetailItem[];
}>('SET_SEARCH_DETAILS_FOR_APPLY');

/** 詳細検索の表示カラム変更アクションクリエータ */
export const setSearchDetailSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_SEARCH_DETAIL_SELECTED_COLUMNS');

/** 詳細検索（申請用）の表示カラム変更アクションクリエータ */
export const setSearchDetailForApplySelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_SEARCH_DETAIL_FOR_APPLY_SELECTED_COLUMNS');

/**
 * カテゴリマスタ設定アクションクリエータ
 */
export const setCategoryMst = actionCreator<{
	careerCategories: ICategoryMst[];
	skillCategories: ICategoryMst[];
	curriculumCategories: ICategoryMst[];
}>('SET_CATEGORY_MST');

/**
 * カテゴリ検索用選択中キャリア設定アクションクリエータ
 */
export const setCategorySelectedCareers = actionCreator<{
	selectedCareers: ISelectedCareer[];
}>('SET_CATEGORY_SELECTED_CAREERS');

/**
 * 詳細検索用選択中キャリア設定アクションクリエータ
 */
export const setDetailSelectedCareers = actionCreator<{
	selectedCareers: ISelectedCareer[];
}>('SET_DETAIL_SELECTED_CAREERS');

/**
 * 申請対象選択用選択中キャリア設定アクションクリエータ
 */
export const setApplicationSelectedCareers = actionCreator<{
	selectedCareers: ISelectedCareer[];
}>('SET_APPLICATION_SELECTED_CAREERS');

/**
 * 申請対象確認画面アクションクリエータ
 */
export const openApprovalTargetCheck = actionCreator<{
	isOpenApprovalTargetCheck: boolean;
}>('OPEN_APPROVAL_TARGET_CHECK');

/**
 * 申請画面アクションクリエータ
 */
export const openApprovals = actionCreator<{
	isOpenApprovals: boolean;
}>('OPEN_APPROVALS');

/**
 * 申請情報設定アクションクリエータ
 */
export const setApprovals = actionCreator<{
	data: IApprovalItem[];
}>('SET_APPROVALS');

/** 受講申請の表示カラム変更アクションクリエータ */
export const setApprovalsSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_APPROVALS_SELECTED_COLUMNS');

/** 受講申請の表示カラム変更アクションクリエータ */
export const setApprovalsSelectedColumnsForStayMeal = actionCreator<{
	selectedColumns: number[];
}>('SET_APPROVALS_SELECTED_COLUMNS_STAYMEAL');

/**
 * 受講申請結果設定アクションクリエータ
 */
export const setApprovalResult = actionCreator<{
	data: IApprovalResult;
	isOpenApprovalResult: boolean;
}>('SET_APPROVAL_RESULT');

/**
 * 受講申請可否情報設定アクションクリエータ
 */
export const setCanApproval = actionCreator<{
	data: IApprovalResultErrorMessage;
	isOpenCanApproval: boolean;
}>('SET_CAN_APPROVAL');

/**
 * 受講申請確認ダイアログ表示アクションクリエータ
 */
export const openApprovalConfirm = actionCreator<{
	open: boolean;
}>('OPEN_APPROVAL_CONFIRM');

/**
 * 詳細検索条件 分類選択ポップアップ表示アクションクリエータ
 */
export const openSearchCondCategorySelect = actionCreator<{
	open: boolean;
}>('OPEN_SEARCH_COND_CATEGORY_SELECT');

/**
 * 詳細検索用選択中キャリア設定アクションクリエータ
 */
export const setSearchInfo = actionCreator<{
	cmFlg: string;
	skillCodeList: ISkillCode[];
}>('SET_SEARCH_INFO');



// WEBPACK FOOTER //
// ./src/actions/search.ts